import VideoOperationSuggestion from './video-operation-suggestion';

export default VideoOperationSuggestion;
